import React from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";

export default function CodeBlock({ code, language = "bash", title, testId }) {
  const { t } = useLang();
  const [copied, setCopied] = React.useState(false);
  const doCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    toast.success(t("common.copied_toast"));
    setTimeout(() => setCopied(false), 1200);
  };
  return (
    <div className="lp-terminal" data-testid={testId}>
      <div className="lp-terminal-header">
        <div className="flex items-center gap-1.5">
          <div className="lp-terminal-dot bg-[#ff5f57]"></div>
          <div className="lp-terminal-dot bg-[#febc2e]"></div>
          <div className="lp-terminal-dot bg-[#28c840]"></div>
        </div>
        <span className="text-xs text-white/40 font-mono ml-2">
          {title || language}
        </span>
        <button
          onClick={doCopy}
          className="ml-auto flex items-center gap-1 text-xs text-white/60 hover:text-[#d4af37] transition-colors font-mono"
          data-testid={testId ? `${testId}-copy` : "code-copy"}
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
          {copied ? t("common.copied") : t("common.copy")}
        </button>
      </div>
      <pre className="p-4 text-sm text-white/85 font-mono leading-6 overflow-x-auto no-scrollbar whitespace-pre">
        <code>{code}</code>
      </pre>
    </div>
  );
}
